<ng-container *ngIf="worker">
<c-card *transloco="let t">
  <c-card-body class="container-sm px-2">
          <c-row>
            <c-col md="12" lg="6">
                <h3>{{ t('Update') }} {{worker.name}}</h3>
            </c-col>
            <c-col md="12" lg="6" class="text-end mb-2">

              <div class="btn-group mb-2 " role="group">
                <button color="light" cButton routerLink="/mgmt/workers/workers">
                    <svg cIcon class="me-2" name="cil-chevron-left"></svg>
                    {{ t('Return to Workers') }}
                </button>
                <a href="https://okalone.zendesk.com/hc/en-gb/categories/35344534733713-Monitors" class="btn btn-primary" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
                <button cButton class="my-2" color="info" class="text-white" (click)="doActivate()" *ngIf="okService.hasFeature('license_mgmt')">
                  <i class="fa-solid fa-toggle-off"></i>&nbsp;{{ t('Deactivate' )}}
                </button>
                <button cButton class="my-2" color="danger" class="text-white" (click)="doDelete()" *ngIf="!okService.isExtendedPrivacy() && this.okService.hasMonitorAccess('workers','delete')">
                  <i class="fa-solid fa-x"></i>&nbsp;{{ t('Delete') }}
                </button>
              </div>





            </c-col>
          </c-row>

          <c-row *ngIf="worker">
            <c-col>
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a class="nav-link active" (click)="tab='info'" [class.active]="tab=='info'">{{ t('Worker Info') }}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" (click)="tab='checkin'" [class.active]="tab=='checkin'">{{ t('Check In Setup') }}</a>
                </li>
                <li class="nav-item" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update')">
                  <a class="nav-link" (click)="tab='shift'" [class.active]="tab=='shift'" *ngIf="okService.hasFeature('start_end_shift')">{{ t('Start/End Shift Reminders') }}</a>
                </li>
                @if(okService.hasFeature('escalation_procedure')){
                <li class="nav-item" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update')">
                  <a class="nav-link" (click)="tab='escalation'" [class.active]="tab=='escalation'">{{ t('Escalation Procedure') }}</a>
                </li>
                }
                <li class="nav-item" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update')">
                  <a class="nav-link" (click)="tab='safetyzone'" [class.active]="tab=='safetyzone'" *ngIf="okService.hasFeature('safety_zones')">{{ t('Safety Zone') }}</a>
                </li>
                <li class="nav-item" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update')">
                  <a class="nav-link" (click)="tab='app'" [class.active]="tab=='app'">{{ t('App Information') }}</a>
                </li>
                <li class="nav-item" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update') && showPermissionsTab()">
                  <a class="nav-link" (click)="tab='permissions'" [class.active]="tab=='permissions'">{{ t('Permissions') }}</a>
                </li>
                <li class="nav-item" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update')">
                  <a class="nav-link" (click)="tab='spot'" [class.active]="tab=='spot'" *ngIf="okService.hasFeature('spot')">{{ t('SPOT Device') }}</a>
                </li>
                <li class="nav-item" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update')">
                  <a class="nav-link" (click)="tab='ihelp'" [class.active]="tab=='ihelp'" *ngIf="okService.hasFeature('ihelp')">{{ t('iHelp Device') }}</a>
                </li>
                <li class="nav-item" *ngIf="this.okService.hasMonitorWorkerAccess('workers','update')">
                  <a class="nav-link" (click)="tab='zoleo'" [class.active]="tab=='zoleo'" *ngIf="okService.hasFeature('zoleo')">{{ t('ZOLEO Device') }}</a>
                </li>
              </ul>
            </c-col>
          </c-row>
          <c-row>
            <c-col class="pt-3">
              <app-worker-info *ngIf="tab=='info'" [worker]="worker" (refreshWorker)="getWorker()"></app-worker-info>

              <app-worker-checkin *ngIf="tab=='checkin'" [worker]="worker" (refreshWorker)="getWorker()"></app-worker-checkin>

              <app-worker-shift *ngIf="tab=='shift'" [worker]="worker" (refreshWorker)="getWorker()"></app-worker-shift>

              <app-worker-escalation *ngIf="tab=='escalation'" [worker]="worker" (refreshWorker)="getWorker()"></app-worker-escalation>

              <app-worker-safetyzone *ngIf="tab=='safetyzone'" [worker]="worker" (refreshWorker)="getWorker()"></app-worker-safetyzone>

              <app-worker-app *ngIf="tab=='app'" [worker]="worker" (refreshWorker)="getWorker()"></app-worker-app>

              <app-worker-permissions *ngIf="tab=='permissions' && showPermissionsTab()" [worker]="worker"></app-worker-permissions>

              <app-worker-spot *ngIf="tab=='spot'" [worker]="worker" (refreshWorker)="getWorker()"></app-worker-spot>

              <app-worker-ihelp *ngIf="tab=='ihelp'" [worker]="worker" (refreshWorker)="getWorker()"></app-worker-ihelp>

              <app-worker-zoleo *ngIf="tab=='zoleo'" [worker]="worker" (refreshWorker)="getWorker()"></app-worker-zoleo>

            </c-col>
          </c-row>

  </c-card-body>
</c-card>

</ng-container>
